<template>
  <section class="s-pt-60 s-pb-30 c-gutter-60 c-mb-30">
    <div class="container">
      <div class="row">          
        <main class="col-lg-7 col-xl-8">            
          <!-- componente  -->
          <Nextexpo/>
          <hr>
          <Lastexpo/>          
          <hr>
          <!-- notis 1 -->
        </main>
        <!--eof .col-md-* (main content)-->
        <!-- sidebar -->
        <Sidebar/>
        <!-- eof aside sidebar -->
      </div>
    </div>
  </section>
</template>

<script>

import Nextexpo from "@/components/layouts/inicio/Next-expo.vue"
import Lastexpo from "@/components/layouts/inicio/Last-expo.vue"
import Notificaciones from "@/components/layouts/inicio/Notificaciones.vue"
import Sidebar from "@/components/layouts/inicio/Sidebar.vue"

export default {
  name: "Inicio",
  components: {
      Sidebar,
      Nextexpo,
      Lastexpo
  },
  data() {
    return {
      show: true
    };
  }
};
</script>
